export const schema = {
  models: {
    TranslationKey: {
      name: "TranslationKey",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        key: {
          name: "key",
          isArray: false,
          type: "String",
          isRequired: true,
          attributes: [],
        },
        translations: {
          name: "translations",
          isArray: true,
          type: {
            model: "Translation",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: ["translationKeyID"],
          },
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: "TranslationKeys",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
                provider: "iam",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["Admin"],
                operations: ["create", "update", "delete", "read"],
              },
            ],
          },
        },
      ],
    },
    Language: {
      name: "Language",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        locale: {
          name: "locale",
          isArray: false,
          type: "String",
          isRequired: true,
          attributes: [],
        },
        nativeName: {
          name: "nativeName",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        displayName: {
          name: "displayName",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        published: {
          name: "published",
          isArray: false,
          type: "Boolean",
          isRequired: false,
          attributes: [],
        },
        translations: {
          name: "translations",
          isArray: true,
          type: {
            model: "Translation",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: ["languageID"],
          },
        },
        imageFiles: {
          name: "imageFiles",
          isArray: true,
          type: {
            model: "ImageFileLanguage",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: ["language"],
          },
        },
        videoFiles: {
          name: "videoFiles",
          isArray: true,
          type: {
            model: "VideoFileLanguage",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: ["language"],
          },
        },
        documentFiles: {
          name: "documentFiles",
          isArray: true,
          type: {
            model: "DocumentFileLanguage",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: ["language"],
          },
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: "Languages",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
                provider: "iam",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["Admin"],
                operations: ["create", "update", "delete", "read"],
              },
            ],
          },
        },
      ],
    },
    Translation: {
      name: "Translation",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        translationKeyID: {
          name: "translationKeyID",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        languageID: {
          name: "languageID",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        value: {
          name: "value",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: "Translations",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "byTranslation",
            fields: ["translationKeyID"],
          },
        },
        {
          type: "key",
          properties: {
            name: "byLanguage",
            fields: ["languageID"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
                provider: "iam",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["Admin"],
                operations: ["create", "update", "delete", "read"],
              },
            ],
          },
        },
      ],
    },
    ImageFile: {
      name: "ImageFile",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        imageFileName: {
          name: "imageFileName",
          isArray: false,
          type: "String",
          isRequired: true,
          attributes: [],
        },
        imageStorageKey: {
          name: "imageStorageKey",
          isArray: false,
          type: "String",
          isRequired: true,
          attributes: [],
        },
        protected: {
          name: "protected",
          isArray: false,
          type: "Boolean",
          isRequired: false,
          attributes: [],
        },
        languages: {
          name: "languages",
          isArray: true,
          type: {
            model: "ImageFileLanguage",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: ["imageFile"],
          },
        },
        playlists: {
          name: "playlists",
          isArray: true,
          type: {
            model: "PlaylistImageFile",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: ["imageFile"],
          },
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: "ImageFiles",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
                provider: "iam",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["Admin"],
                operations: ["create", "update", "delete", "read"],
              },
            ],
          },
        },
      ],
    },
    VideoFile: {
      name: "VideoFile",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        posterFileName: {
          name: "posterFileName",
          isArray: false,
          type: "String",
          isRequired: true,
          attributes: [],
        },
        posterStorageKey: {
          name: "posterStorageKey",
          isArray: false,
          type: "String",
          isRequired: true,
          attributes: [],
        },
        videoFileName: {
          name: "videoFileName",
          isArray: false,
          type: "String",
          isRequired: true,
          attributes: [],
        },
        videoStorageKey: {
          name: "videoStorageKey",
          isArray: false,
          type: "String",
          isRequired: true,
          attributes: [],
        },
        protected: {
          name: "protected",
          isArray: false,
          type: "Boolean",
          isRequired: false,
          attributes: [],
        },
        languages: {
          name: "languages",
          isArray: true,
          type: {
            model: "VideoFileLanguage",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: ["videoFile"],
          },
        },
        playlists: {
          name: "playlists",
          isArray: true,
          type: {
            model: "PlaylistVideoFile",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: ["videoFile"],
          },
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: "VideoFiles",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
                provider: "iam",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["Admin"],
                operations: ["create", "update", "delete", "read"],
              },
            ],
          },
        },
      ],
    },
    DocumentFile: {
      name: "DocumentFile",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        title: {
          name: "title",
          isArray: false,
          type: "String",
          isRequired: true,
          attributes: [],
        },
        documentFileName: {
          name: "documentFileName",
          isArray: false,
          type: "String",
          isRequired: true,
          attributes: [],
        },
        documentStorageKey: {
          name: "documentStorageKey",
          isArray: false,
          type: "String",
          isRequired: true,
          attributes: [],
        },
        protected: {
          name: "protected",
          isArray: false,
          type: "Boolean",
          isRequired: false,
          attributes: [],
        },
        languages: {
          name: "languages",
          isArray: true,
          type: {
            model: "DocumentFileLanguage",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: ["documentFile"],
          },
        },
        contentPages: {
          name: "contentPages",
          isArray: true,
          type: {
            model: "ContentPageDocumentFile",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: ["documentFile"],
          },
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: "DocumentFiles",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
                provider: "iam",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["Admin"],
                operations: ["create", "update", "delete", "read"],
              },
            ],
          },
        },
      ],
    },
    Playlist: {
      name: "Playlist",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        name: {
          name: "name",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        imageFiles: {
          name: "imageFiles",
          isArray: true,
          type: {
            model: "PlaylistImageFile",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: ["playlist"],
          },
        },
        videoFiles: {
          name: "videoFiles",
          isArray: true,
          type: {
            model: "PlaylistVideoFile",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: ["playlist"],
          },
        },
        contentPages: {
          name: "contentPages",
          isArray: true,
          type: {
            model: "ContentPagePlaylist",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: ["playlist"],
          },
        },
        sequence: {
          name: "sequence",
          isArray: true,
          type: "ID",
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: "Playlists",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
                provider: "iam",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["Admin"],
                operations: ["create", "update", "delete", "read"],
              },
            ],
          },
        },
      ],
    },
    ContentPage: {
      name: "ContentPage",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        uniqueName: {
          name: "uniqueName",
          isArray: false,
          type: "String",
          isRequired: true,
          attributes: [],
        },
        titleTranslationKey: {
          name: "titleTranslationKey",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        sloganTranslationKey: {
          name: "sloganTranslationKey",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        featuresTranslationKey: {
          name: "featuresTranslationKey",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        benefitsTranslationKey: {
          name: "benefitsTranslationKey",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        documentFiles: {
          name: "documentFiles",
          isArray: true,
          type: {
            model: "ContentPageDocumentFile",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: ["contentPage"],
          },
        },
        playlists: {
          name: "playlists",
          isArray: true,
          type: {
            model: "ContentPagePlaylist",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: ["contentPage"],
          },
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: "ContentPages",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
                provider: "iam",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["Admin"],
                operations: ["create", "update", "delete", "read"],
              },
            ],
          },
        },
      ],
    },
    ImageFileLanguage: {
      name: "ImageFileLanguage",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        imageFileID: {
          name: "imageFileID",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        languageID: {
          name: "languageID",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        imageFile: {
          name: "imageFile",
          isArray: false,
          type: {
            model: "ImageFile",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetNames: ["imageFileID"],
          },
        },
        language: {
          name: "language",
          isArray: false,
          type: {
            model: "Language",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetNames: ["languageID"],
          },
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: "ImageFileLanguages",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "byImageFile",
            fields: ["imageFileID"],
          },
        },
        {
          type: "key",
          properties: {
            name: "byLanguage",
            fields: ["languageID"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
                provider: "iam",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["Admin"],
                operations: ["create", "update", "delete", "read"],
              },
            ],
          },
        },
      ],
    },
    VideoFileLanguage: {
      name: "VideoFileLanguage",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        videoFileID: {
          name: "videoFileID",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        languageID: {
          name: "languageID",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        videoFile: {
          name: "videoFile",
          isArray: false,
          type: {
            model: "VideoFile",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetNames: ["videoFileID"],
          },
        },
        language: {
          name: "language",
          isArray: false,
          type: {
            model: "Language",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetNames: ["languageID"],
          },
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: "VideoFileLanguages",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "byVideoFile",
            fields: ["videoFileID"],
          },
        },
        {
          type: "key",
          properties: {
            name: "byLanguage",
            fields: ["languageID"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
                provider: "iam",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["Admin"],
                operations: ["create", "update", "delete", "read"],
              },
            ],
          },
        },
      ],
    },
    DocumentFileLanguage: {
      name: "DocumentFileLanguage",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        documentFileID: {
          name: "documentFileID",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        languageID: {
          name: "languageID",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        documentFile: {
          name: "documentFile",
          isArray: false,
          type: {
            model: "DocumentFile",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetNames: ["documentFileID"],
          },
        },
        language: {
          name: "language",
          isArray: false,
          type: {
            model: "Language",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetNames: ["languageID"],
          },
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: "DocumentFileLanguages",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "byDocumentFile",
            fields: ["documentFileID"],
          },
        },
        {
          type: "key",
          properties: {
            name: "byLanguage",
            fields: ["languageID"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
                provider: "iam",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["Admin"],
                operations: ["create", "update", "delete", "read"],
              },
            ],
          },
        },
      ],
    },
    PlaylistImageFile: {
      name: "PlaylistImageFile",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        imageFileID: {
          name: "imageFileID",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        playlistID: {
          name: "playlistID",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        imageFile: {
          name: "imageFile",
          isArray: false,
          type: {
            model: "ImageFile",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetNames: ["imageFileID"],
          },
        },
        playlist: {
          name: "playlist",
          isArray: false,
          type: {
            model: "Playlist",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetNames: ["playlistID"],
          },
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: "PlaylistImageFiles",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "byImageFile",
            fields: ["imageFileID"],
          },
        },
        {
          type: "key",
          properties: {
            name: "byPlaylist",
            fields: ["playlistID"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
                provider: "iam",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["Admin"],
                operations: ["create", "update", "delete", "read"],
              },
            ],
          },
        },
      ],
    },
    PlaylistVideoFile: {
      name: "PlaylistVideoFile",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        videoFileID: {
          name: "videoFileID",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        playlistID: {
          name: "playlistID",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        videoFile: {
          name: "videoFile",
          isArray: false,
          type: {
            model: "VideoFile",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetNames: ["videoFileID"],
          },
        },
        playlist: {
          name: "playlist",
          isArray: false,
          type: {
            model: "Playlist",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetNames: ["playlistID"],
          },
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: "PlaylistVideoFiles",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "byVideoFile",
            fields: ["videoFileID"],
          },
        },
        {
          type: "key",
          properties: {
            name: "byPlaylist",
            fields: ["playlistID"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
                provider: "iam",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["Admin"],
                operations: ["create", "update", "delete", "read"],
              },
            ],
          },
        },
      ],
    },
    ContentPageDocumentFile: {
      name: "ContentPageDocumentFile",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        documentFileID: {
          name: "documentFileID",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        contentPageID: {
          name: "contentPageID",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        documentFile: {
          name: "documentFile",
          isArray: false,
          type: {
            model: "DocumentFile",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetNames: ["documentFileID"],
          },
        },
        contentPage: {
          name: "contentPage",
          isArray: false,
          type: {
            model: "ContentPage",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetNames: ["contentPageID"],
          },
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: "ContentPageDocumentFiles",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "byDocumentFile",
            fields: ["documentFileID"],
          },
        },
        {
          type: "key",
          properties: {
            name: "byContentPage",
            fields: ["contentPageID"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
                provider: "iam",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["Admin"],
                operations: ["create", "update", "delete", "read"],
              },
            ],
          },
        },
      ],
    },
    ContentPagePlaylist: {
      name: "ContentPagePlaylist",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        contentPageID: {
          name: "contentPageID",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        playlistID: {
          name: "playlistID",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        contentPage: {
          name: "contentPage",
          isArray: false,
          type: {
            model: "ContentPage",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetNames: ["contentPageID"],
          },
        },
        playlist: {
          name: "playlist",
          isArray: false,
          type: {
            model: "Playlist",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetNames: ["playlistID"],
          },
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
          isReadOnly: true,
        },
      },
      syncable: true,
      pluralName: "ContentPagePlaylists",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "byContentPage",
            fields: ["contentPageID"],
          },
        },
        {
          type: "key",
          properties: {
            name: "byPlaylist",
            fields: ["playlistID"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
                provider: "iam",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["Admin"],
                operations: ["create", "update", "delete", "read"],
              },
            ],
          },
        },
      ],
    },
  },
  enums: {},
  nonModels: {},
  codegenVersion: "3.3.6",
  version: "33166db3fbdf635dd9d5a62bdc820d99",
};
